var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1533 18C13.0361 18.2021 12.8679 18.3698 12.6655 18.4864C12.4631 18.6029 12.2336 18.6643 12 18.6643C11.7664 18.6643 11.5369 18.6029 11.3345 18.4864C11.1321 18.3698 10.9639 18.2021 10.8467 18",
    stroke: "#E1E5ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33337C16 8.27251 15.5786 7.25509 14.8284 6.50495C14.0783 5.7548 13.0609 5.33337 12 5.33337C10.9391 5.33337 9.92172 5.7548 9.17157 6.50495C8.42143 7.25509 8 8.27251 8 9.33337C8 14 6 15.3334 6 15.3334H18C18 15.3334 16 14 16 9.33337Z",
    stroke: "#E1E5ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 4,
    fill: "#60C67C",
    stroke: "#0D2045",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bellNotification.361bce56655f92ca22bbd26565ec0011.svg";
export { ForwardRef as ReactComponent };